// deno-fmt-ignore-file
import { EnumToUnion } from '../../type/engine/enum/index.mjs';
import { FromType } from './from-type.mjs';
export function FromEnum(context, type) {
    return FromType(context, EnumToUnion(type));
}
